import React, { useState, useEffect } from 'react';
import MainTable from '../../components/Table/PaginationTable.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FileOutlineIcon from '@mui/icons-material/Description';
import { useTranslation } from 'react-i18next';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import { Menu, MenuItem } from '@mui/material';
import { Button } from 'react-bootstrap';
import { PartnerProfileColumnDefDefaultFnC } from './column/columnDef.js';
import { fetchPartnerProfileData } from '../../redux/partnerProfileSlice.js';
import FilterPanelPartnerProfile from '../../components/common components/FilterPanelPartnerProfile.js';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
dayjs.extend(localizedFormat);
const formattedDate = dayjs().format('LL');

const PartnerProfileLandingPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // const { data, loading, error } = useState(''); // Assuming the state shape
  const tableData = useSelector(state => state.partnerProfile.partnerProfileData) || []
  const isLoading = useSelector(state => state.partnerProfile.loading);
  const isError = useSelector(state => state.partnerProfile.error);
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const totalRecords = useSelector(state => state.partnerProfile.paginationInfo?.totalRecords) || 0;
  const [filterCriteria, setFilterCriteria] = useState({
      searchText: '',
  }); 
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [actionType, setActionType] = useState('')

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

   // Function to handle filter action
   const handleFilter = (criteria) => {
    const formattedCriteria = {
      searchText: criteria.search,
      country:criteria.countries.join(','),
      companyTypeId:criteria.companyTypeId
    };
    setFilterCriteria(formattedCriteria);
    // Perform filtering logic based on criteria
    const queryParams = {
      type: 'vcpPartner',
      pageSize,
      pageNumber,
      country: formattedCriteria.country,
      companyTypeName: formattedCriteria.companyTypeId,
      searchText: formattedCriteria.searchText,
      approvalStatus: 0,
    };
    dispatch(fetchPartnerProfileData(queryParams));
  };

  // Function to handle reset action
  const handleReset = () => {   
    // Perform reset logic
    const queryParams = {
      searchText: '',
      pageSize, // Use state value
      pageNumber, // Use state value
      approvalStatus: 0,
      country: '',
      companyTypeName: '',
      type: 'vcpPartner'
    };
    dispatch(fetchPartnerProfileData(queryParams));
  };

  useEffect(() => {
    const queryParams = {
      searchText: '',
      pageSize, // Use state value
      pageNumber, // Use state value
      approvalStatus: 0,
      country: '',
      companyTypeName: '',
      type: 'vcpPartner'
    };
    dispatch(fetchPartnerProfileData(queryParams));
  }, [dispatch, pageSize, pageNumber]);
  
  const navigateCallback = (companyId) => {
    navigate(`/view-partner-profile/${companyId}`);
  };
 
const columnDef = PartnerProfileColumnDefDefaultFnC(navigateCallback,t);

  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1); // Reset to the first page when page size changes
  };

  // if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {isError}</div>;

  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div>
          </div>
          <div>
            <button className="btn btn-light grey-btn md_btn me-0" onClick={() => setIsFilterPanelOpen(prevState => !prevState)}>
              <span><i className="bi bi-funnel"><FilterAltOutlinedIcon /></i></span> Filters
      
            </button>
          </div>
        </div>
      </div>
      {isFilterPanelOpen && <FilterPanelPartnerProfile className='mb-3' onFilter={handleFilter} onReset={handleReset} />}
      <MainTable
        columns={columnDef}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords} // Pass the totalRecords to MainTable
        recordCountText="total records"
      />
    </>
  )
}

export default PartnerProfileLandingPage;
